
import React from "react";
import { LucideProps } from "lucide-react";

export const DailymotionIcon = ({ 
  size = 24, 
  className = "", 
  ...props 
}: LucideProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      strokeWidth="0"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 19.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm-1.294-3.38h2.589V8.324H10.706v7.796z" />
    </svg>
  );
};

export default DailymotionIcon;
